export const getDeviceInfo = () => {
    try {
        const resolucionPantalla = `${window.screen.width}x${window.screen.height}`;
        const zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return {
            resolucionPantalla,
            zonaHoraria
        };
    } catch (e) {
        return {
            resolucionPantalla: null,
            zonaHoraria: null
        };
    }
};

export const getGeolocation = () => {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            resolve({ latitud: null, longitud: null });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    latitud: position.coords.latitude,
                    longitud: position.coords.longitude
                });
            },
            (error) => {
                // Denied or error
                resolve({ latitud: null, longitud: null });
            },
            {
                timeout: 5000,
                maximumAge: 60000
            }
        );
    });
};
